import { Injectable } from '@angular/core';
import { ProjectService } from '@wms/services';
import { every, forEach, isNull } from 'lodash-es';
import { BaseVariableService, VARIABLE_CONSTANTS } from '@wms/variables';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WmsLogoutVariableService {
  propertyGroupChangeSubject = new Subject();
  triggeredSubscription: boolean;

  constructor(private projectService: ProjectService, private variableService: BaseVariableService) { }

  __getVariableDependencies() {
    let pagesMap = {};
    /*Construncting the pages map*/
    forEach(this.projectService.getPageNames('PAGE'), (page) => {
        pagesMap[page] = page;
    });
    this.variableService.selectedVariable.propertyObj.redirectTo.options = pagesMap;
  }

  __onPropertyChange(propertyName: any, value?: any) {
    /*
    * executing the event change method to create callback variables.
    */
    this.variableService.markUpdated();
    if (VARIABLE_CONSTANTS.EVENTS.indexOf(propertyName) > -1) {
      this.variableService.onEventChange(propertyName, value);
    }
    const isEmptyVal = every(value, v => v === '' || isNull(v))

    if ((propertyName === 'spinnerContext' || propertyName === 'redirectTo') && isEmptyVal && !this.triggeredSubscription) {
      this.triggeredSubscription = true;
      this.propertyGroupChangeSubject.next(true);
      return;
    } else if (!isEmptyVal) {
      this.triggeredSubscription = false;
      this.propertyGroupChangeSubject.next(true);
    }
  }
}
